export interface IFactoryModel {
    businessLicense: string;
    cityId: string;
    cityName: string;
    createTime: string;
    districtId: string;
    districtName: string;
    email: string;
    enterpriseFullName: string;
    enterpriseShortName: string;
    examineState: number;
    id: string;
    mobile: string;
    provinceId: string;
    provinceName: string;
    state: number;
    unifiedSocialCreditCode: string;
}

export interface IFactory extends IFactoryModel {
    rowNum: number;
    updateTime: string;
}

export interface IUserState extends IFactoryModel {
    token: string;
}

export interface IFactoryTable {
    page: number;
    limit: number;
    page_count: number;
    total_rows: number;
    rows: IFactory [];
}

export interface IFactoryState {
    keyWord: string;
    factorys: IFactoryTable;
}

export enum EXAMINE_STATE {
    NOEXAMINE,
    PASS,
    NOPASS
}